import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminPortal from './components/AdminPortal';
import Landing from './components/Landing';
import Login from './components/Login';
import Engineering from './pages/Engineering';
import Management from './pages/Management';
import Placements from './pages/Placements';
import About from './pages/About';
import Research from './pages/Research';
import Innovations from './pages/Innovations';
import Contact from './pages/Contact';
import StudentDesk from './pages/StudentDesk';
import Gallery from './pages/Gallery';
import NewsEvents from './pages/NewsEvents';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import Notice from './pages/Notice';
import NotFound from './components/NotFound';
import WhatsAppButton from './components/landing/WhatsAppButton';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

function AppContent() {
  const location = useLocation();
  const isWebAdmin = location.pathname.startsWith('/admin');
  
  return (
    <>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/engineering" element={<Engineering />} />
        <Route path="/management" element={<Management />} />
        <Route path="/placements" element={<Placements />} />
        <Route path="/about" element={<About />} />
        <Route path="/research" element={<Research />} />
        <Route path="/innovations" element={<Innovations />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/student-desk" element={<StudentDesk />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/news-events" element={<NewsEvents />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog-details" element={<BlogDetails />} />
        <Route path="/notice" element={<Notice />} />
        
        {/* Protected Admin Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/admin" element={<AdminPortal />} />
          <Route path="/admin/*" element={<AdminPortal />} />
        </Route>

        {/* Fallback 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isWebAdmin && <WhatsAppButton />}
    </>
  );
}

export default App;